/*
    Create by BaiZhiming 2015-12-28
*/
'use strict';
angular
    .module('trsSelectDocumentModule', [
        'trsSelectDocumentForSTModule',
        'copyIdsModule',
        'trsSelectDocumentNewModule',
        'selectDocumentInternalLinkModule',
        'trsSelectLiveSignedDocumentModule',
    ])
    .factory('trsSelectDocumentService', [
        '$modal',
        '$q',
        function($modal, $q) {
            return {
                trsSelectDocument: function(params, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/selectDocument/selectDocument_tpl.html',
                        windowClass: 'mutildocsDlg',
                        backdrop: false,
                        controller: 'trsSelectDocumentCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },
                trsSelectDocumentForST: function(params, success) {
                    $modal.open({
                        templateUrl: './components/service/selectDocument/selectDocumentForSmallTopic_tpl.html',
                        windowClass: 'mutildocsDlg',
                        backdrop: false,
                        controller: 'trsSelectDocumentForSTCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                copyIds: function(ids, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/selectDocument/copyIds_tpl.html',
                        windowClass: 'toBeCompiled-review-window',
                        backdrop: false,
                        controller: 'copyIdsCtrl',
                        resolve: {
                            copyParams: function() {
                                return {
                                    ids: ids,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },

                /**
                 * [trsSelectDocumentNew description]新版选择稿件
                 * @param  {[array]} docs [description]已选稿件列表
                 * @param  {[array]} required [description]需要填写的字段
                 * @param  {[array]} widgetParams [description]需要填写的字段
                 * @return {[array]}      [description] 选择完成的稿件列表
                 */
                trsSelectDocumentNew: function(docs, required, widgetParams) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/selectDocument/selectDocumentNew/selectDocumentNew_tpl.html',
                        windowClass: 'trs-select-document-new',
                        backdrop: false,
                        controller: 'trsSelectDocumentNewCtrl',
                        resolve: {
                            params: function() {
                                return {
                                    docs: docs,
                                    required: required,
                                    widgetParams: widgetParams,
                                };
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },

                /**
                 * [insertInternalLink description] 插入内链
                 * @return {[type]} [description]
                 */
                trsSelectDocumentInternalLink: function() {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/selectDocument/selectDocumentInternalLink/selectDocumentInternalLink_tpl.html',
                        windowClass: 'insert-internalLink-window',
                        backdrop: false,
                        controller: 'selectDocumentInternalLinkCtrl',
                    });
                    modalInstance.result.then(function(result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                },

                /**
                 * [trsSelectLiveSignedDocument description] 插入直播（APP已签发的直播稿）
                 * @param  {[type]} params  [description]
                 * @param  {[type]} success [description]
                 * @return {[type]}         [description]
                 */
                trsSelectLiveSignedDocument: function(params, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/selectDocument/selectLiveSignedDocument/selectLiveSignedDocument_tpl.html',
                        windowClass: 'mutildocsDlg',
                        backdrop: false,
                        controller: 'trsSelectLiveSignedDocumentCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },
            };
        },
    ])
    .controller('trsSelectDocumentCtrl', [
        '$scope',
        '$q',
        '$modalInstance',
        'params',
        'trsHttpService',
        'initSingleSelecet',
        'trsspliceString',
        'modalDialog',
        'localStorageService',
        'websiteLeftService',
        function(
            $scope,
            $q,
            $modalInstance,
            params,
            trsHttpService,
            initSingleSelecet,
            trsspliceString,
            modalDialog,
            localStorageService,
            websiteLeftService
        ) {
            // var centerPageSize = window.innerWidth <= 1440 ? 10 : 15;
            var centerPageSize = 9;
            initStatus();
            initData();
            $scope.showSelected = function(node) {
                memorySelectedChannel(node.CHANNELID);
                $scope.status.isChooseSite = false;
                $scope.params.SearchDocId = '';
                $scope.params.SearchTitle = '';
                $scope.params.SearchRecId = '';
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: centerPageSize,
                    PAGECOUNT: 1,
                    ITEMCOUNT: '',
                };
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                $scope.params.ChannelId = node.CHANNELID; // 重置分页
                siteOrChannel();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    $scope.items = data.DATA;
                    if (!!data.PAGER) {
                        $scope.page = data.PAGER;
                    } else {
                        $scope.page.ITEMCOUNT = '0';
                    }
                    // !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = "0";
                });
            };
            $scope.showToggle = function(node) {
                if (angular.isDefined(node.CHILDREN) && node.CHILDREN.length === 0 && node.HASCHILDREN === 'true') {
                    var childrenTreeParam = {
                        serviceid: 'mlf_mediasite',
                        methodname: 'queryClassifyByChnlWithOutRight',
                        ChannelId: node.CHANNELID,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), childrenTreeParam, 'get').then(function(data) {
                        node.CHILDREN = data.CHILDREN;
                    });
                }
            };
            $scope.pageChanged = function() {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestDataPromise(true);
            };
            $scope.rightPageChanged = function() {
                getRightList();
            };

            /**
             * [jumpToPage description]跳转指定页面
             *
             * @return  {[type]}   [return description]
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestDataPromise(true);
            };

            /**
             * [rightJumpToPage description]右侧已选稿件列表跳转
             *
             * @return  {[type]}   [return description]
             */
            $scope.rightJumpToPage = function() {
                $scope.rightListPage.CURRPAGE = $scope.status.rightCopyCurrPage;
                getRightList();
            };

            /**
             * [openDetail description]打开详情页
             *
             * @param  {[type]}  item   [item description]
             *
             * @return  {[type]}[return description]
             */
            $scope.openDetail = function(item) {
                var router =
                    '#/websitepreview?' +
                    'channelid=' +
                    $scope.selectedNode.CHANNELID +
                    '&' +
                    'siteid=' +
                    $scope.selectedNode.SITEID +
                    '&' +
                    'chnldocid=' +
                    item.RECID +
                    '&' +
                    'metadataid=' +
                    item.METADATAID +
                    '&' +
                    'typeid=' +
                    item.DOCTYPEID +
                    '&' +
                    'platform=2';
                window.open(router);
            };

            /**
             * [openPuburl description]打开发布地址
             *
             * @param  {[type]}  item   [item description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.openPuburl = function(item) {
                if ($scope.status.isApp === false) {
                    window.open(item.DOCPUBURL);
                }
            };
            // 全选
            $scope.selectAll = function() {
                if (checkSelectedAll()) {
                    $scope.selectedArray = angular.copy($scope.initialSelectedArray);
                } else {
                    angular.forEach($scope.items, function(data, index) {
                        if (!duplChecking([data], $scope.selectedArray).flag) {
                            $scope.selectedArray.splice(0, 0, angular.copy(data));
                        }
                    });
                    // $scope.selectedArray = $scope.items.concat($scope.selectedArray);
                }
                getRightList();
                // if ($scope.selectedArray.length > 50) $scope.selectedArray.length = $scope.rightListPage.ITEMCOUNT;
            };
            // 单选
            $scope.selectDoc = function(item) {
                if (!duplChecking([item], $scope.selectedArray).flag) {
                    $scope.selectedArray.splice(0, 0, angular.copy(item));
                } else {
                    var checkMessage = duplChecking([item], $scope.selectedArray);
                    if (checkMessage.flag) {
                        $scope.selectedArray.splice(checkMessage.index, 1);
                    }
                }

                /* if ($scope.selectedArray.length > 50) {
                    $scope.selectedArray.length = $scope.rightListPage.ITEMCOUNT;
                }*/
                getRightList();
            };
            // 检测选中情况
            $scope.checkChecked = function(item) {
                var flag = false;
                angular.forEach($scope.selectedArray, function(data, index, array) {
                    if (item.METADATAID === data.METADATAID || item.RECID === data.RECID) {
                        flag = true;
                    }
                });
                return flag;
            };
            $scope.checkSelectedAll = function() {
                return checkSelectedAll();
            };

            /**
             * [checkSelectedAll description]
             *
             * @return  {[type]}   [return description]
             */
            function checkSelectedAll() {
                var flag = true;
                if ($scope.selectedArray.length == 0 || !angular.isDefined($scope.items)) {return false;}
                var itemMetadaids = trsspliceString.spliceString($scope.items, 'METADATAID', ',').split(',');
                var selectedMetadaids = trsspliceString.spliceString($scope.selectedArray, 'METADATAID', ',').split(',');
                for (var i = 0; i < itemMetadaids.length; i++) {
                    if (selectedMetadaids.indexOf(itemMetadaids[i]) < 0) {
                        flag = false;
                        break;
                    }
                }
                return flag;
            }
            $scope.delSelected = function(item) {
                var checkMessage = duplChecking([item], $scope.selectedArray);
                if (checkMessage.flag) {
                    $scope.selectedArray.splice(checkMessage.index, 1);
                }
                getRightList();
            };

            $scope.sureChked = function() {
                var docData = [];
                angular.forEach($scope.selectedArray, function(data, index) {
                    if (!duplChecking([data], $scope.initialSelectedArray).flag) {
                        $scope.addNewArray.push(data);
                    }
                });
                angular.forEach($scope.addNewArray, function(data, index, array) {
                    docData.push(transformData(data));
                });
                // angular.forEach($scope.initialSelectedArray, function(data, index) {
                //     $scope.initialSelectedArray[index] = transformData(data);
                // });
                $modalInstance.close(docData);
            };

            /**
             * [transformData description]数据格式转换
             *
             * @param  {[type]}  data   [data description]
             *
             * @return  {[type]}   [return description]
             */
            function transformData(data) {
                let obj = {
                    title: $scope.status.isApp === true ? data.LISTTITLE : data.TITLE,
                    subtitle: data.HOMETITLE,
                    url: data.DOCPUBURL,
                    titlecolor: data.TITLECOLOR,
                    abstract: data.ABSTRACT,
                    isRelNews: true,
                    recid: data.RECID,
                    reltime: data.RELTIME,
                    metadataId: data.METADATAID,
                    source: data.source,
                    author: data.author,
                };
                // if (angular.isDefined(params.IsPicDoc)) {
                if (angular.isDefined(data.OUTLINEPICS) && data.OUTLINEPICS !== '' && angular.isDefined(data.OUTLINEPICS.PICSLOGO)) {
                    obj.imgsrc = data.OUTLINEPICS.PICSLOGO.split(',')[data.OUTLINEPICS.PICSLOGO.split(',').length - 1];
                    obj.imgName = obj.imgsrc.split('=')[obj.imgsrc.split('=').length - 1];
                } else if (angular.isDefined(data.METALOGOURL) && data.METALOGOURL !== '' && angular.isDefined(data.METALOGOURL.PICSLOGO)) {
                    obj.imgsrc = data.METALOGOURL.PICSLOGO.split(',')[data.METALOGOURL.PICSLOGO.split(',').length - 1];
                    obj.imgName = obj.imgsrc.split('=')[obj.imgsrc.split('=').length - 1];
                } else {
                    obj.imgsrc = '';
                    obj.imgName = '';
                }
                // }
                return obj;
            }
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [initData description]
             *
             * @return  {[type]}   [return description]
             */
            function initData() {
                getRightList();
                if (params.isExcludeSpecialDoc) {
                    $scope.params.isExcludeSpecialDoc = true; // 排除专题稿， SearchTitle=&methodname=queryMetaByChannel&serviceid=mlf_metadata，目前只用于网站专题稿
                }
                $scope.items = [];
                $scope.treeOptions = {
                    nodeChildren: 'CHILDREN',
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: 'a1',
                        li: 'a2',
                        liSelected: 'a7',
                        iExpanded: 'a3',
                        iCollapsed: 'a4',
                        iLeaf: 'a5',
                        label: 'a6',
                        labelSelected: '',
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN === 'false';
                    },
                };
                $scope.loadingPromise = getTreeData().then(function() {
                    $scope.params.ChannelId = $scope.selectedNode.CHANNELID;
                    $scope.loadingPromise = requestDataPromise(true);
                });
                // 初始化下拉框
                initDropList();
            }

            /**
             * [getTreeData description]获取左侧树数据
             * @return {[type]} [description]
             */
            function getTreeData() {
                var deffer = $q.defer();
                var treeParam = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryClassifyBySiteWithOutRight',
                    SiteId: params.siteid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), treeParam, 'get').then(function(data) {
                    $scope.siteDesc = data.SITEDESC;
                    $scope.treeData = data.CHILDREN;

                    var memoryChannelid = localStorageService.get('selectDocumentChannelMemory');
                    if (memoryChannelid !== null) {
                        firstColumnCheck($scope.treeData, memoryChannelid).then(
                            function(data) {
                                $scope.selectedNode = data;
                                deffer.resolve(data);
                            },
                            function() {
                                websiteLeftService
                                    .positionSelectChannel($scope.treeData, memoryChannelid, params.platform, $scope.expandedTest)
                                    .then(function(selectedChannel) {
                                        $scope.selectedNode = selectedChannel;
                                        deffer.resolve(selectedChannel);
                                    });
                            }
                        );
                    } else {
                        for (var i = 0; i < $scope.treeData.length; i++) {
                            if ($scope.treeData[i].CHANNELID === $scope.params.ChannelId) {
                                $scope.selectedNode = $scope.treeData[i];
                                break;
                            }
                        }
                        deffer.resolve(data);
                    }

                    /* var index = 0;
                        for (var i = 0; i < $scope.treeData.length; i++) {
                            if ($scope.treeData[i].CHANNELID === params.channelid) {
                                index = i;
                                break;
                            }
                        }
                        $scope.selectedNode = $scope.treeData[index];
                        $scope.params.ChannelId = $scope.treeData[index].CHANNELID;
                        requestDataPromise(true);*/
                });
                return deffer.promise;
            }

            /**
             * [firstColumnCheck description]一级栏目选中检查
             * @param  {[type]} treeData  [description]
             * @param  {[type]} channelid [description]
             * @return {[type]}           [description]
             */
            function firstColumnCheck(treeData, channelid) {
                var deffer = $q.defer();
                var flag = false;
                var selectedChannel;
                for (var i = 0; i < treeData.length; i++) {
                    var data = treeData[i];
                    if (data.CHANNELID === channelid) {
                        selectedChannel = data;
                        flag = true;
                        break;
                    }
                }
                if (flag) {
                    deffer.resolve(selectedChannel);
                } else {
                    deffer.reject();
                }
                return deffer.promise;
            }

            /**
             * [memorySelectedChannel description]记忆选择过的栏目，方便下次操作
             * @param  {[type]} channelid [description]
             * @return {[type]}           [description]
             */
            function memorySelectedChannel(channelid) {
                localStorageService.set('selectDocumentChannelMemory', channelid);
            }
            
            /**
             * [getRightList description]初始化右侧列表
             *
             * @return  {[type]}   [return description]
             */
            function getRightList() {
                var pageCount = Math.ceil($scope.selectedArray.length / $scope.rightListPage.PAGESIZE);
                var selectedArrayCopy = angular.copy($scope.selectedArray);
                $scope.rightListPage.PAGECOUNT = pageCount == 0 ? 1 : pageCount;
                $scope.rightListPage.ITEMCOUNT = selectedArrayCopy.length;
                if ($scope.rightListPage.CURRPAGE > $scope.rightListPage.PAGECOUNT) {$scope.rightListPage.CURRPAGE = angular.copy($scope.rightListPage.PAGECOUNT);}
                $scope.selectedArrayCurPage = selectedArrayCopy.splice(
                    ($scope.rightListPage.CURRPAGE - 1) * $scope.rightListPage.PAGESIZE,
                    $scope.rightListPage.PAGESIZE
                );
                // $scope.selectedArrayCurPage = $scope.selectedArray/
            }

            /**
             * [initStatus description]
             *
             * @return  {[type]}   [return description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: centerPageSize,
                };
                $scope.rightListPage = {
                    CURRPAGE: 1,
                    PAGESIZE: centerPageSize - 1,
                    // "ITEMCOUNT": 50
                };
                $scope.params = {
                    serviceid: angular.isDefined(params.isApp) && params.isApp === true ? 'mlf_appmetadata' : 'mlf_metadata',
                    methodname: 'queryMetaByChannel',
                    IsPicDoc: false,
                    PageSize: $scope.page.PAGESIZE,
                    CurrPage: $scope.page.CURRPAGE,
                    ChannelId: '',
                    IsCurrentChnl: false,
                    SearchDocId: '',
                    SearchRecId: '',
                    SearchTitle: '',
                    DocType: angular.isDefined(params.docType) ? params.docType : '',
                    SearchSpecialDoc: angular.isDefined(params.searchSpecialDoc) ? params.searchSpecialDoc : false,
                };
                $scope.status = {
                    fromFragment: !params.position,
                    isChooseSite: false,
                    searchAll: [
                        {
                            name: '标题',
                            value: '0',
                            placeholder: '输入关键字搜索',
                        },
                        {
                            name: 'ID',
                            value: '1',
                            placeholder: '请输入稿件ID',
                        },
                    ],
                    searchPosition: {
                        0: 'SiteId',
                        1: 'ChannelId',
                    },
                    SearchValue: '',
                    copyCurrPage: 1,
                    rightCopyCurrPage: 1,
                    isApp: !!(angular.isDefined(params.isApp) && params.isApp === true),
                    selectedLength: angular.isDefined(params.relNewsLength) ? params.relNewsLength : params.relNewsData.length,
                };
                $scope.data = {
                    dropDown: {
                        searchAllType: $scope.status.searchAll,
                        searchAllSelected: $scope.status.searchAll[0],
                    },
                };
                $scope.selectedArray = params.relNewsData;
                $scope.initialSelectedArray = angular.copy(params.relNewsData);
                $scope.addNewArray = [];
                // $scope.hasMeta = false;
                /*
                  判断使用metaDataId还是recId  
                 */
                $scope.status.showMetadaId = !!(angular.isDefined(params.showMetadaId) && params.showMetadaId === true);

                /* if (params.showMetadaId == 0) {
                    $scope.hasMeta = angular.isDefined(params.relNewsData[0].METADATAID) ? true : false;
                }*/
            }
            $scope.isSelectDisabled = function(item) {
                var isSelected = false;
                angular.forEach($scope.initialSelectedArray, function(data, index, array) {
                    if (item.METADATAID === data.METADATAID || item.RECID === data.RECID) {
                        isSelected = true;
                    }
                });
                return isSelected;
            };

            /**
             * [requestDataPromise description]
             *
             * @param  {[type]}  callback   [callback description]
             *
             * @return  {[type]}   [return description]
             */
            function requestDataPromise(callback) {
                var deferred = $q.defer();
                siteOrChannel();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    if (angular.isDefined(callback)) {
                        $scope.items = data.DATA;
                        $scope.page = data.PAGER;
                        if (!angular.isDefined($scope.page)) {
                            $scope.page = {
                                PAGESIZE: 0,
                                ITEMCOUNT: 0,
                                PAGECOUNT: 0,
                            };
                        }
                        // angular.isDefined($scope.page) ? "" : $scope.page = {
                        //     "PAGESIZE": 0,
                        //     "ITEMCOUNT": 0,
                        //     "PAGECOUNT": 0
                        // };
                    }
                    deferred.resolve();
                });
                return deferred.promise;
            }

            /**
             * [initDropList description]初始化下拉框
             *
             * @return  {[type]}   [return description]
             */
            function initDropList() {
                // ES条件
                $scope.data.dropDown.esAll = initSingleSelecet.iWoEntire();
                $scope.data.dropDown.esSelected = angular.copy($scope.data.dropDown.esAll[0]);
            }

            /**
             * [duplChecking description]查重复
             *
             * @param  {[type]}  items   [items description]
             * @param  {[type]}  array   [array description]
             *
             * @return  {[type]}   [return description]
             */
            function duplChecking(items, array) {
                var flag = false;
                var arrayIndex = 0;
                angular.forEach(array, function(data, index, array) {
                    var attribute = angular.isDefined(data.RECID) ? 'RECID' : 'METADATAID';
                    angular.forEach(items, function(_data, _index, _array) {
                        if (_data[attribute] === data[attribute]) {
                            flag = true;
                            arrayIndex = index;
                        }
                    });
                });
                return { flag: flag, index: arrayIndex };
            }

            /**
             * [unique description]去重复
             *
             * @param  {[type]}  arr1   [arr1 description]
             * @param  {[type]}  arr2   [arr2 description]
             *
             * @return  {[type]}   [return description]
             */
            function unique(arr1, arr2) {
                var allArr = arr1.concat(arr2),
                    result = [],
                    flag = {};
                angular.forEach(allArr, function(data, key) {
                    var id = angular.isDefined(data.METADATAID) ? data.METADATAID : data.RECID;
                    if (!flag[id]) {
                        result.push(data);
                        flag[id] = true;
                    }
                });
                return result;
            }

            /**
             * [chooseSite description]选择整个站点（仅用于检索）
             *
             * @return  {[type]}   [return description]
             */
            $scope.chooseSite = function() {
                $scope.status.isChooseSite = true;
                $scope.params.SearchDocId = '';
                $scope.params.SearchRecId = '';
                $scope.params.SearchTitle = '';
                requestDataPromise(true);
            };

            /**
             * [fullTextSearch description]全文检索
             *
             * @param  {[type]}  ev   [ev description]按下空格也能提交
             *
             * @return  {[type]}   [return description]
             */
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if (!checkSearchValue()) {return;}
                    $scope.page.CURRPAGE = 1;
                    requestDataPromise(true);
                }
            };
            // $scope.status.isChooseSite ? params.siteid : $scope.params.channelId
            /**
             * [siteOrChannel description]区分是站点还是栏目的搜索
             *
             * @return  {[type]}   [return description]
             */
            function siteOrChannel() {
                if (!$scope.status.isChooseSite) {
                    // $scope.params.ChannelId = node.CHANNELID;
                    if (angular.isDefined($scope.params.SiteId)) {delete $scope.params.SiteId;}
                } else {
                    $scope.params.SiteId = params.siteid;
                    if (angular.isDefined($scope.params.ChannelId)) {delete $scope.params.ChannelId;}
                }
            }

            /**
             * [checkSearchValue description]检查输入的关键字是否正确
             *
             * @return  {[type]}   [return description]
             */
            function checkSearchValue() {
                var flag = true;
                if ($scope.data.dropDown.searchAllSelected.value == 1) {
                    if ($scope.status.showMetadaId) {
                        if (!isNaN($scope.status.SearchValue) || $scope.status.SearchValue === '') {
                            $scope.params.SearchDocId = angular.copy($scope.status.SearchValue);
                        } else {
                            modalDialog.alertType('请输入ID数字', '', 'warning', false);
                            flag = false;
                        }
                    } else {
                        if (!isNaN($scope.status.SearchValue) || $scope.status.SearchValue === '') {
                            $scope.params.SearchRecId = angular.copy($scope.status.SearchValue);
                        } else {
                            modalDialog.alertType('请输入ID数字', '', 'warning', false);
                            flag = false;
                        }
                    }
                    if (angular.isDefined($scope.params.SearchTitle)) {delete $scope.params.SearchTitle;}
                } else {
                    $scope.params.SearchTitle = angular.copy($scope.status.SearchValue);
                    if (angular.isDefined($scope.params.SearchDocId)) {delete $scope.params.SearchDocId;}
                    if (angular.isDefined($scope.params.SearchRecId)) {delete $scope.params.SearchRecId;}
                }
                return flag;
            }
        },
    ]);
